var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidaws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(-755 -308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(755 308)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 76,
    height: 76,
    rx: 3,
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "android",
    transform: "translate(9.012 5.843)",
    opacity: 0.764
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M113.843,155.433V184.8c0,2.293,1.377,4.092,3.737,4.092h3.081a2.268,2.268,0,0,0-.343,1.16v8.317a4.335,4.335,0,0,0,8.634,0V190.05a2.137,2.137,0,0,0-.519-1.16h7.516a2.136,2.136,0,0,0-.521,1.16v8.317a4.335,4.335,0,0,0,8.634,0V190.05a2.269,2.269,0,0,0-.342-1.16h3.086c2.36,0,3.732-1.8,3.732-4.092V155.433H113.843Z",
    transform: "translate(-103.489 -137.429)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M31.745,158.977a4.238,4.238,0,0,0-4.317,3.936v16.853a4.335,4.335,0,0,0,8.634,0V162.914A4.239,4.239,0,0,0,31.745,158.977Z",
    transform: "translate(-27.428 -139.005)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M139.627,5.674l.753-1.105.754-1.092,1.68-2.455a.641.641,0,0,0-.187-.91.678.678,0,0,0-.931.183l-2.565,3.737-.772,1.126a23.143,23.143,0,0,0-16.047,0l-.767-1.125-.759-1.1L118.984.3a.689.689,0,0,0-.938-.183.648.648,0,0,0-.188.91l1.679,2.456.754,1.093.758,1.1c-5.724,2.6-9.6,7.739-9.6,13.136H149.22C149.22,13.414,145.348,8.27,139.627,5.674Zm-17.385,7.9a1.969,1.969,0,1,1,2.024-1.971A2,2,0,0,1,122.242,13.571Zm16.189,0a1.969,1.969,0,1,1,2.024-1.971A2,2,0,0,1,138.431,13.571Z",
    transform: "translate(-101.635 0)",
    fill: "#57c927"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M31.937,197.866c-1.683,0-3.43-1.588-4.509-4.105v16.1a4.335,4.335,0,0,0,8.634,0V194.6C34.983,196.623,33.422,197.866,31.937,197.866Z",
    transform: "translate(-27.428 -169.243)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M415.745,158.977a4.238,4.238,0,0,0-4.317,3.936v16.853a4.335,4.335,0,0,0,8.634,0V162.914A4.239,4.239,0,0,0,415.745,158.977Z",
    transform: "translate(-361.142 -139.005)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(9.817 9.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M415.937,197.866c-1.683,0-3.43-1.588-4.509-4.105v16.1a4.335,4.335,0,0,0,8.634,0V194.6C418.983,196.623,417.422,197.866,415.937,197.866Z",
    transform: "translate(-370.959 -178.481)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M133.775,164.008c-8.537,0-16.189-.988-18.347-2.389v28.529c0,2.293,1.377,4.092,3.737,4.092h3.081a2.268,2.268,0,0,0-.343,1.16v8.317a4.335,4.335,0,0,0,8.634,0V195.4a2.136,2.136,0,0,0-.519-1.16h7.516a2.136,2.136,0,0,0-.521,1.16v8.317a4.335,4.335,0,0,0,8.634,0V195.4a2.269,2.269,0,0,0-.342-1.16h3.086c2.36,0,3.732-1.8,3.732-4.092v-28.53C149.964,163.019,142.313,164.008,133.775,164.008Z",
    transform: "translate(-114.892 -152.354)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M140.455,73a2.025,2.025,0,0,1-4.049,0,1.929,1.929,0,0,1,.693-1.472,41.738,41.738,0,0,0-13.525,0A1.925,1.925,0,0,1,124.267,73a2.025,2.025,0,0,1-4.048,0,1.925,1.925,0,0,1,.168-.784,24.477,24.477,0,0,0-8.114,3.617,14.321,14.321,0,0,0-.821,4.379H149.22a14.33,14.33,0,0,0-.82-4.376,24.432,24.432,0,0,0-8.112-3.621A1.956,1.956,0,0,1,140.455,73Z",
    transform: "translate(-111.452 -70.977)",
    fill: "#1cb71c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M133.016,238.546c-6.97,0-13.45-1.434-17.588-3.785v18.662c0,2.293,1.32,4.093,3.583,4.093h2.954a2.337,2.337,0,0,0-.329,1.16v8.317a4.144,4.144,0,0,0,8.277,0v-8.317a2.177,2.177,0,0,0-.5-1.16h7.205a2.176,2.176,0,0,0-.5,1.16v8.317a4.144,4.144,0,0,0,8.277,0v-8.317a2.338,2.338,0,0,0-.328-1.16h2.958c2.263,0,3.578-1.8,3.578-4.093V234.761C146.466,237.113,139.986,238.546,133.016,238.546Z",
    transform: "translate(-103.556 -206.055)",
    fill: "#049e42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(23.024 31.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M21.529,7.81a3.109,3.109,0,0,0,.113.915,5.5,5.5,0,0,0,.329.74.447.447,0,0,1,.072.236.407.407,0,0,1-.2.308l-.647.432a.493.493,0,0,1-.267.092.473.473,0,0,1-.308-.144,3.179,3.179,0,0,1-.37-.483c-.1-.175-.206-.37-.319-.606a3.8,3.8,0,0,1-3.021,1.418,2.815,2.815,0,0,1-2.055-.74,2.64,2.64,0,0,1-.76-1.973,2.645,2.645,0,0,1,.935-2.117,3.738,3.738,0,0,1,2.517-.8,8.136,8.136,0,0,1,1.089.082c.38.051.771.134,1.182.226v-.75A2.277,2.277,0,0,0,19.34,3a2.365,2.365,0,0,0-1.675-.473,4.675,4.675,0,0,0-1.11.134,8.188,8.188,0,0,0-1.11.349,2.948,2.948,0,0,1-.36.134.63.63,0,0,1-.164.031c-.144,0-.216-.1-.216-.319v-.5a.65.65,0,0,1,.072-.36.769.769,0,0,1,.288-.216,5.916,5.916,0,0,1,1.295-.462,6.23,6.23,0,0,1,1.6-.2,3.755,3.755,0,0,1,2.692.832,3.4,3.4,0,0,1,.853,2.528V7.81ZM17.357,9.372a3.33,3.33,0,0,0,1.058-.185,2.29,2.29,0,0,0,.976-.658,1.631,1.631,0,0,0,.349-.658,3.689,3.689,0,0,0,.1-.894V6.546a8.581,8.581,0,0,0-.945-.175,7.743,7.743,0,0,0-.966-.062,2.369,2.369,0,0,0-1.531.411A1.432,1.432,0,0,0,15.9,7.9a1.326,1.326,0,0,0,1.459,1.469Zm8.251,1.11a.574.574,0,0,1-.39-.1.837.837,0,0,1-.216-.4L22.588,2.035a1.8,1.8,0,0,1-.092-.411.225.225,0,0,1,.247-.257h1.007a.57.57,0,0,1,.4.1.841.841,0,0,1,.206.4l1.726,6.8,1.6-6.8a.721.721,0,0,1,.2-.4.707.707,0,0,1,.411-.1h.822a.618.618,0,0,1,.411.1.692.692,0,0,1,.2.4l1.624,6.885L33.12,1.871a.881.881,0,0,1,.206-.4.67.67,0,0,1,.4-.1h.956a.228.228,0,0,1,.257.257,1.024,1.024,0,0,1-.021.164,1.462,1.462,0,0,1-.072.257L32.37,9.988a.788.788,0,0,1-.216.4.657.657,0,0,1-.39.1H30.88a.618.618,0,0,1-.411-.1.728.728,0,0,1-.2-.411L28.681,3.35,27.1,9.968a.8.8,0,0,1-.2.411.637.637,0,0,1-.411.1Zm13.2.277a6.8,6.8,0,0,1-1.582-.185,4.675,4.675,0,0,1-1.182-.411.74.74,0,0,1-.319-.288.725.725,0,0,1-.062-.288V9.063c0-.216.082-.319.236-.319a.582.582,0,0,1,.185.031c.062.021.154.062.257.1a5.589,5.589,0,0,0,1.13.36,6.171,6.171,0,0,0,1.223.123,2.772,2.772,0,0,0,1.5-.339,1.107,1.107,0,0,0,.534-.976,1,1,0,0,0-.277-.719,2.578,2.578,0,0,0-1.038-.534l-1.49-.462a3.134,3.134,0,0,1-1.644-1.048,2.448,2.448,0,0,1-.514-1.49,2.287,2.287,0,0,1,.277-1.141,2.642,2.642,0,0,1,.74-.843,3.261,3.261,0,0,1,1.069-.534A4.478,4.478,0,0,1,39.152,1.1a5.158,5.158,0,0,1,.688.041c.236.031.452.072.668.113s.4.1.586.164a2.243,2.243,0,0,1,.432.185.888.888,0,0,1,.308.257.554.554,0,0,1,.092.339v.483c0,.216-.082.329-.236.329a1.069,1.069,0,0,1-.39-.123,4.7,4.7,0,0,0-1.973-.4,2.652,2.652,0,0,0-1.367.288.992.992,0,0,0-.483.915.97.97,0,0,0,.308.73,3.069,3.069,0,0,0,1.13.565l1.459.462a3.125,3.125,0,0,1,1.593.986,2.325,2.325,0,0,1,.473,1.439,2.641,2.641,0,0,1-.267,1.192,2.763,2.763,0,0,1-.75.9,3.312,3.312,0,0,1-1.141.575A4.886,4.886,0,0,1,38.812,10.759Z",
    transform: "translate(-12.823 -1.1)",
    fill: "#252f3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(0 11.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M29.6,121.666a22.164,22.164,0,0,1-12.515,3.822A22.642,22.642,0,0,1,1.8,119.663c-.319-.288-.031-.678.349-.452a30.346,30.346,0,0,0,26.952,1.675C29.672,120.628,30.155,121.255,29.6,121.666Z",
    transform: "translate(-1.668 -118.531)",
    fill: "#f90",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M250.221,114.724c-.432-.555-2.857-.267-3.956-.134-.329.041-.38-.247-.082-.462,1.932-1.356,5.107-.966,5.477-.514s-.1,3.638-1.911,5.158c-.277.236-.545.113-.421-.2C249.739,117.56,250.653,115.269,250.221,114.724Z",
    transform: "translate(-220.882 -113.192)",
    fill: "#f90",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidaws);
export default __webpack_public_path__ + "static/media/androidaws.d44c54261f126c7de8773b3c0c993304.svg";
export { ForwardRef as ReactComponent };